export const productToBenefitsMap: Record<
  string,
  { header?: string; items: string[] }
> = {
  "ed-ot": {
    header: "welcome.ed-ot.benefits.header",
    items: [
      "welcome.ed-ot.benefits.item.0",
      "welcome.ed-ot.benefits.item.1",
      "welcome.ed-ot.benefits.item.2",
      "welcome.ed-ot.benefits.item.3",
    ],
  },
  "amh-ot": {
    header: "welcome.amh-ot.benefits.header",
    items: [
      "welcome.amh-ot.benefits.item.0",
      "welcome.amh-ot.benefits.item.1",
      "welcome.amh-ot.benefits.item.2",
      "welcome.amh-ot.benefits.item.3",
    ],
  },
};
